<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<ngb-toast
*ngFor="let toast of toastService.toasts; trackBy: trackByToastId"
[class]="toast.classname"
[autohide]="toast.autohide ?? true"
[delay]="toast.delay || 5000"
(hide)="toastService.remove(toast)"
(hidden)="toastService.remove(toast)"
>
<!-- Toast Layout - ALWAYS includes icon -->
<div class="toast-layout">
  <!-- Toast Icon - ALWAYS shown -->
  <div class="toast-icon">
    <ng-container [ngSwitch]="toast.type || 'info'">
      <img *ngSwitchCase="'success'" src="assets/img/svgs/success-toast-icon.svg" alt="Success" width="16" height="16" />
      <img *ngSwitchCase="'error'" src="assets/img/svgs/error-toast-icon.svg" alt="Error" width="16" height="16" />
      <img *ngSwitchCase="'warning'" src="assets/img/svgs/warning-toast-icon.svg" alt="Warning" width="16" height="16" />
      <img *ngSwitchCase="'info'" src="assets/img/svgs/info-toast-icon.svg" alt="Info" width="16" height="17" />
      <img *ngSwitchDefault src="assets/img/svgs/info-toast-icon.svg" alt="Info" width="16" height="17" />
    </ng-container>
  </div>

  <!-- Toast Content - Template or Standard -->
  <div class="toast-content">
    <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="standardContent">
      <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    </ng-template>

    <ng-template #standardContent>
      <div class="toast-header" *ngIf="toast.header">
        {{ toast.header }}
      </div>
      <div class="toast-body">
        {{ toast.textOrTpl }}
        <a *ngIf="toast.link?.url"
           [href]="toast.link.url"
           target="_blank"
           rel="noopener noreferrer"
           class="toast-link">
          {{ toast.link.text }}
        </a>
      </div>
    </ng-template>
  </div>

  <!-- Toast Close Button - ALWAYS shown -->
  <button type="button"
          class="toast-close"
          (click)="toastService.remove(toast)"
          [attr.aria-label]="'Close toast'"
          title="Close">
    <i class="fal fa-times"></i>
  </button>
</div>

</ngb-toast>
